export const CHANGE_THEME_COLORS = "CHANGE_THEME_COLORS";

export function changeThemeColors(themeColors) {
  return {
    themeColors,
    type: CHANGE_THEME_COLORS
  };
}
